import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/AliceAgentAppForm';

import { LocalizedString } from './LocalizedTextInputs';

const t = i18n(keyset);

import type { UserAgreementOrDraft } from 'client/model/userAgreement';

export interface FormState {
    name: string;
    agentName: string;
    title: LocalizedString;
    shortDescription: LocalizedString;
    aliases: string[];
    availableInPlusMenu: boolean;
    availableWithoutLogin: boolean;
    logoId?: string;
    logoUrl?: string;
    chatTestingEnabled: boolean;
    userAgreements: UserAgreementOrDraft[];
}

/** Allowed in `agentName`: Latin ASCII letters (any case), digits, dashes, underscores; 1+ chars long. */
const AGENT_NAME_RE = /^[a-zA-Z0-9_-]+$/;

/** Per-field synchronous validators consumed by TanStack `form.Field({ validators: { onChange } })`. */
export const validators = {
    name: ({ value }: { value: string }) => (value.trim() ? undefined : t('validation-required')),
    agentName: ({ value }: { value: string }) => {
        const trimmed = value.trim();
        if (!trimmed) return t('validation-required');
        if (!AGENT_NAME_RE.test(trimmed)) return t('validation-agent-name-format');
        return undefined;
    },
    logoId: ({ value }: { value: string | undefined }) => (value ? undefined : t('validation-required')),
};

/**
 * Maps server-side validation keys (dotted paths used by the backend) to local form-state keys
 * so we can attach API errors to the right inputs via `form.setFieldMeta`.
 */
export const agentAppServerKeyMap: Record<string, keyof FormState> = {
    name: 'name',
    'manifest.config.agentName': 'agentName',
    logoId: 'logoId',
};
